<template>
  <div id="app">
    <Header v-if="this.mountHeader" />
    <AdminHeader v-if="this.adminHeader" />
    <div class="body-container scroll-margin">
      <div v-if="this.isMenuView">
        <RouterView/>
      </div>
      <div v-if="this.isIndexView">
        <RouterView />
      </div>
    </div>
    <Footer class="footer-container" v-if="this.mountFooter" />
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import AdminHeader from "@/components/admin/common/AdminHeader.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    AdminHeader
  },
  computed: {
    mountHeader() {
      const routeName = this.$route?.name ?? this.$route?.matched?.[0]?.name ?? '';
      return (
        this.$route.name !== "404" &&
        this.$route.name !== "admin" &&
        this.$route.name !== "notice01List" &&
        this.$route.name !== "notice01Write" &&
        this.$route.name !== "notice01Modify" &&
        this.$route.name !== "notice01View" &&
        this.$route.name !== "presPls01List" &&
        this.$route.name !== "presPls01Write" &&
        this.$route.name !== "presPls01View" &&
        this.$route.name !== "ir01List" &&
        this.$route.name !== "ir01Write" &&
        this.$route.name !== "ir01Modify" &&
        this.$route.name !== "ir01View" &&
        this.$route.name !== "minwon01List" &&
        this.$route.name !== "minwon01View" &&
        this.$route.name !== "minwon02List" &&
        this.$route.name !== "minwon02View" &&
        this.$route.name !== "voucherRequest"
      );
    },
    adminHeader() {
      return (
        this.$route.name == "admin" ||
        this.$route.name == "notice01List" ||
        this.$route.name == "notice01Write" ||
        this.$route.name == "notice01Modify" ||
        this.$route.name == "notice01View" ||
        this.$route.name == "presPls01List" ||
        this.$route.name == "presPls01Write" ||
        this.$route.name == "presPls01View" ||
        this.$route.name == "ir01List" ||
        this.$route.name == "ir01Write" ||
        this.$route.name == "ir01Modify" ||
        this.$route.name == "ir01View" ||
        this.$route.name == "minwon01List" ||
        this.$route.name == "minwon01View" ||
        this.$route.name == "minwon02List" ||
        this.$route.name == "minwon02View"
      );
    },
    isMenuView() {
      return (
        this.$route.name !== "404" && 
        this.$route.name != "MainPage" &&
        this.$route.name != "Service01"
      );
    },
    isIndexView() {
      return (
        this.$route.name == "MainPage" ||
        this.$route.name == "Service01"
      );
    },
    mountLeftMenu01() {
      return this.$route.name !== "404";
    },
    mountFooter() {
      return (
        this.$route.name !== "404" &&
        this.$route.name !== "admin" && 
        this.$route.name !== "notice01List" && 
        this.$route.name !== "notice01Write" && 
        this.$route.name !== "notice01Modify" && 
        this.$route.name !== "notice01View" &&
        this.$route.name !== "presPls01List" &&
        this.$route.name !== "presPls01Write" &&
        this.$route.name !== "presPls01View" && 
        this.$route.name !== "ir01List" && 
        this.$route.name !== "ir01Write" && 
        this.$route.name !== "ir01Modify" && 
        this.$route.name !== "ir01View" &&
        this.$route.name !== "minwon01List" &&
        this.$route.name !== "minwon01View" &&
        this.$route.name !== "minwon02List" &&
        this.$route.name !== "minwon02View" &&
        this.$route.name !== "voucherRequest"
      );
    },
  },
  
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "jua";
  src: url("@/assets/fonts/BMJUA_ttf.ttf");
}
@font-face {
  font-family: "dohyeon";
  src: url("@/assets/fonts/BMDOHYEON_ttf.ttf");
}
@import '@/assets/css/add.css';
@import '@/assets/css/admin-style.css';
@import '@/assets/css/admin.css';
@import '@/assets/css/common.css';
@import '@/assets/css/default-color.css';
@import '@/assets/css/default.css';
@import '@/assets/css/employment.css';
@import '@/assets/css/fontawesome.css';
@import '@/assets/css/fonts.css';
@import '@/assets/css/glyphicon.css';
@import '@/assets/css/jquery-ui.min.css';
@import '@/assets/css/nicednb.css';
@import '@/assets/css/reset.css';
@import '@/assets/css/service.css';
@import '@/assets/css/style.css';
@import '@/assets/css/voucher.css';
</style>

